import { createFeatureSelector, createSelector } from '@ngrx/store';
import {DeviceState} from "./device.state";

export const selectDeviceState = createFeatureSelector<DeviceState>("device");

export const selectAllDevices = createSelector(
  selectDeviceState,
  (state) => state.devices
);

export const selectDeviceLoading = createSelector(
  selectDeviceState,
  (state) => state.loading
);

export const selectDeviceError = createSelector(
  selectDeviceState,
  (state) => state.error
);

// If you want a selector for a single group by ID:
export const selectDeviceById = (id: string) =>
  createSelector(selectAllDevices, (devices) => devices.find((g) => g.id === id));